import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { PDFRendererWrapper as CompiledPDFRendererWrapper } from './pdfRendererWrapper-compiled';
import { PDFRendererWrapper as EmotionPDFRendererWrapper } from './pdfRendererWrapper-emotion';
export var PDFRendererWrapper = function PDFRendererWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledPDFRendererWrapper, props) : /*#__PURE__*/React.createElement(EmotionPDFRendererWrapper, props);
};